<input
  #inputElement
  type="tel"
  [id]="inputId"
  [name]="name"
  [class]="inputClass"
  [ngClass]="{ empty: !value, 'has-error': hasError }"
  [(ngModel)]="value"
  [mask]="isCnpj ? '00.000.000/0000-00' : '000.000.000-00' + (cpfOnly ? '' : '?0')"
  [validation]="false"
  [dropSpecialCharacters]="dropSpecialCharacters"
  [specialCharacters]="['.', '-', '/']"
  (ngModelChange)="onValueChange()"
  [autocomplete]="autocomplete"
  [disabled]="disabled"
  [attr.tabindex]="tabindex"
  [appValidCpf]="enableValidation && !isCnpj"
  [appValidCnpj]="enableValidation && isCnpj"
  role="presentation"
/>
@if (label) {
  <label class="field__placeholder" [for]="inputId">{{ label }}</label>
}
